/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Model_DeepInputs */



/**
* | output |
* | --- |
* | "Deep" |
*
* @param {Assistant_Model_DeepInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_model_deep = /** @type {((inputs?: Assistant_Model_DeepInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Model_DeepInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profond")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tief")
	if (locale === "it") return /** @type {LocalizedString} */ ("Profondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Глубокий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Profundo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("深的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("深い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गहरा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Profundo")
	return /** @type {LocalizedString} */ ("Deep")
});